module.exports = __webpack_public_path__ + "img/imgtaskget.23d6806b.png";